import React from "react";
import { X } from "@phosphor-icons/react";

function personName(contact) {
  return [contact?.firstName, contact?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
}

function statusLabel(contact) {
  return contact?.lifecycleStage === "client" ? "Client" : "Prospect";
}

export default function CommerceMapResultsPanel({
  title,
  subtitle,
  contacts,
  onClose,
  onOpenContact,
}) {
  return (
    <aside className="flex h-full min-h-0 flex-col bg-[var(--do-bg-solid)] lg:w-[340px] lg:min-w-[340px]">
      <div className="flex items-start justify-between gap-3 border-b border-[var(--do-border)] px-4 py-4">
        <div className="min-w-0">
          <h2 className="truncate font-heading text-base font-black text-[var(--do-ink)]">
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-1 text-xs text-[var(--do-muted)]">{subtitle}</p>
          ) : null}
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Fermer le panneau"
          className="grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-[var(--do-border)] text-[var(--do-muted)] transition hover:bg-[var(--do-bg-2)] hover:text-[var(--do-ink)]"
        >
          <X size={16} weight="bold" />
        </button>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto p-3">
        {contacts.length ? (
          <div className="space-y-2">
            {contacts.map((contact) => {
              const name = personName(contact);
              return (
                <button
                  key={contact.id}
                  type="button"
                  onClick={() => onOpenContact(contact.id)}
                  className="block w-full rounded-xl border border-[var(--do-border)] bg-[var(--do-bg)] px-3 py-3 text-left transition hover:border-[var(--do-border-strong)] hover:bg-[var(--do-bg-2)]"
                >
                  <span className="block truncate text-sm font-bold text-[var(--do-ink)]">
                    {name || contact.company || "Contact"}
                  </span>
                  {name && contact.company ? (
                    <span className="mt-1 block truncate text-xs text-[var(--do-muted)]">
                      {contact.company}
                    </span>
                  ) : null}
                  <span className="mt-2 block truncate text-[11px] text-[var(--do-muted)]">
                    Propriétaire : {contact.ownerName || "Non assigné"}
                  </span>
                  <span className="mt-2 flex items-center justify-between gap-2 text-[11px]">
                    <span className="truncate text-[var(--do-muted)]">
                      {contact.city || "Ville non renseignée"}
                    </span>
                    <span
                      className={
                        contact.lifecycleStage === "client"
                          ? "rounded-full border border-[color-mix(in_srgb,var(--do-success)_35%,transparent)] bg-[color-mix(in_srgb,var(--do-success)_14%,transparent)] px-2 py-1 font-bold text-[var(--do-success)]"
                          : "rounded-full border border-[color-mix(in_srgb,var(--do-accent)_35%,transparent)] bg-[color-mix(in_srgb,var(--do-accent)_12%,transparent)] px-2 py-1 font-bold text-[var(--do-accent)]"
                      }
                    >
                      {statusLabel(contact)}
                    </span>
                  </span>
                </button>
              );
            })}
          </div>
        ) : (
          <div className="flex h-full min-h-40 items-center justify-center px-4 text-center text-sm text-[var(--do-muted)]">
            Aucun contact trouvé.
          </div>
        )}
      </div>
    </aside>
  );
}
